import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PortalVue from "portal-vue";
import { http, homepages } from "./config";
import VCalendar from "v-calendar";

window.events = new Vue();
window.flash = message => {
  window.events.$emit("flash", message);
};

Vue.config.productionTip = false;

Vue.use(PortalVue);
Vue.use(VCalendar);

Vue.prototype.$http = http;

const auth = window.localStorage.getItem("auth");
const role = window.localStorage.getItem("role");

if (auth) {
  var authData = JSON.parse(auth);
  var roleData = JSON.parse(role);
  store.commit("setAuth", authData);
  if (roleData && authData && authData.account && authData.account.roles && authData.account.roles.includes(roleData)) {
    store.commit("setRole", JSON.parse(roleData));
  }
}


router.beforeEach((to, from, next) => {
  if (to.name === "404") {
    next();
  } else if (to.name == "Role") {
    if (!store.getters.isLoggedIn) {
      next('/login')
    } else {
      next();
    }
  } else if (to.meta.requiresAuth && store.getters.isLoggedIn) {
    console.log("logged in");
    if (!store.getters.hasRole) {
      console.log("has no role");
      next('/role')
    } else if (to.meta.allowedRoles.includes(store.state.role)) {
      console.log("allowed");
      next();
      return;
    } else {
      console.log("not allowed");
      window.flash({ type: "error", body: "You need to login!" });
      next("/login");
    }
  } else if (to.meta.requiresGuest && store.getters.isLoggedIn) {
    // get the role homepage
    // redirect to that page
    if (!store.getters.hasRole) {
      next('/role')
      return;
    } else {
      console.log("already logged in");
      next(homepages(store.state.role));
      return;
    }
  } else if (to.meta.requiresGuest) {
    next();
  } else {
    console.log("not logged in");
    next("/login");
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
